// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__4ekDD","content":"SectionHeader_content__nWjlC","title":"SectionHeader_title__BSINu","description":"SectionHeader_description__CmW2j"};